import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faCode } from '@fortawesome/free-solid-svg-icons';
import './Footer.css'

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <section id="footer">
        <div className="container">
          <p>
            Made with <FontAwesomeIcon icon={faHeart} style={{color: '#ef4444'}} /> and <FontAwesomeIcon icon={faCode} /> by Dawit Endaylalu
          </p>
          <p>&copy; {currentYear} All rights reserved. Built with React & modern web technologies.</p>
        </div>
      </section>
    </div>
  );
}
